import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=2c85610a&scoped=true"
var script = {}
import style0 from "./Card.vue?vue&type=style&index=0&id=2c85610a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c85610a",
  null
  
)

export default component.exports